"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.killAgent = exports.deleteKey = exports.setTrustLevel = exports.presetPassphrase = exports.configureAgent = exports.getKeygrip = exports.parseKeygripFromGpgColonsOutput = exports.getKeygrips = exports.importKey = exports.getDirs = exports.getVersion = exports.getHome = exports.agentConfig = void 0;
const exec = __importStar(require("@actions/exec"));
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const os = __importStar(require("os"));
const openpgp = __importStar(require("./openpgp"));
exports.agentConfig = `default-cache-ttl 21600
max-cache-ttl 31536000
allow-preset-passphrase`;
const gpgConnectAgent = (command) => __awaiter(void 0, void 0, void 0, function* () {
    return yield exec
        .getExecOutput(`gpg-connect-agent "${command}" /bye`, [], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
        for (const line of res.stdout.replace(/\r/g, '').trim().split(/\n/g)) {
            if (line.startsWith('ERR')) {
                throw new Error(line);
            }
        }
        return res.stdout.trim();
    });
});
const getHome = () => __awaiter(void 0, void 0, void 0, function* () {
    let homedir = '';
    if (process.env.GNUPGHOME) {
        homedir = process.env.GNUPGHOME;
    }
    else if (os.platform() == 'win32' && !process.env.HOME && process.env.USERPROFILE) {
        homedir = path.join(process.env.USERPROFILE, '.gnupg');
    }
    else if (process.env.HOME) {
        homedir = path.join(process.env.HOME, '.gnupg');
    }
    else {
        homedir = (yield (0, exports.getDirs)()).homedir;
    }
    if (homedir.length == 0) {
        throw new Error('Unable to determine GnuPG home directory');
    }
    if (!fs.existsSync(homedir)) {
        fs.mkdirSync(homedir, { recursive: true });
    }
    return homedir;
});
exports.getHome = getHome;
const getVersion = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield exec
        .getExecOutput('gpg', ['--version'], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
        let gnupgVersion = '';
        let libgcryptVersion = '';
        for (const line of res.stdout.replace(/\r/g, '').trim().split(/\n/g)) {
            if (line.startsWith('gpg (GnuPG) ')) {
                gnupgVersion = line.substr('gpg (GnuPG) '.length).trim();
            }
            else if (line.startsWith('gpg (GnuPG/MacGPG2) ')) {
                gnupgVersion = line.substr('gpg (GnuPG/MacGPG2) '.length).trim();
            }
            else if (line.startsWith('libgcrypt ')) {
                libgcryptVersion = line.substr('libgcrypt '.length).trim();
            }
        }
        return {
            gnupg: gnupgVersion,
            libgcrypt: libgcryptVersion
        };
    });
});
exports.getVersion = getVersion;
const getDirs = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield exec
        .getExecOutput('gpgconf', ['--list-dirs'], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
        let libdir = '';
        let libexecdir = '';
        let datadir = '';
        let homedir = '';
        for (const line of res.stdout.replace(/\r/g, '').trim().split(/\n/g)) {
            if (line.startsWith('libdir:')) {
                libdir = line.substr('libdir:'.length).replace('%3a', ':').trim();
            }
            else if (line.startsWith('libexecdir:')) {
                libexecdir = line.substr('libexecdir:'.length).replace('%3a', ':').trim();
            }
            else if (line.startsWith('datadir:')) {
                datadir = line.substr('datadir:'.length).replace('%3a', ':').trim();
            }
            else if (line.startsWith('homedir:')) {
                homedir = line.substr('homedir:'.length).replace('%3a', ':').trim();
            }
        }
        return {
            libdir: libdir,
            libexecdir: libexecdir,
            datadir: datadir,
            homedir: homedir
        };
    });
});
exports.getDirs = getDirs;
const importKey = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const keyFolder = fs.mkdtempSync(path.join(os.tmpdir(), 'ghaction-import-gpg-'));
    const keyPath = `${keyFolder}/key.pgp`;
    fs.writeFileSync(keyPath, (yield openpgp.isArmored(key)) ? key : Buffer.from(key, 'base64').toString(), { mode: 0o600 });
    return yield exec
        .getExecOutput('gpg', ['--import', '--batch', '--yes', keyPath], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
        if (res.stderr != '') {
            return res.stderr.trim();
        }
        return res.stdout.trim();
    })
        .finally(() => {
        fs.unlinkSync(keyPath);
    });
});
exports.importKey = importKey;
const getKeygrips = (fingerprint) => __awaiter(void 0, void 0, void 0, function* () {
    return yield exec
        .getExecOutput('gpg', ['--batch', '--with-colons', '--with-keygrip', '--list-secret-keys', fingerprint], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        const keygrips = [];
        for (const line of res.stdout.replace(/\r/g, '').trim().split(/\n/g)) {
            if (line.startsWith('grp')) {
                keygrips.push(line.replace(/(grp|:)/g, '').trim());
            }
        }
        return keygrips;
    });
});
exports.getKeygrips = getKeygrips;
const parseKeygripFromGpgColonsOutput = (output, fingerprint) => {
    let keygrip = '';
    let fingerPrintFound = false;
    const lines = output.replace(/\r/g, '').trim().split(/\n/g);
    for (const line of lines) {
        if (line.startsWith(`fpr:`) && line.includes(`:${fingerprint}:`)) {
            // We reach the record with the matching fingerprint.
            // The next keygrip record is the keygrip for this fingerprint.
            fingerPrintFound = true;
            continue;
        }
        if (line.startsWith('grp:') && fingerPrintFound) {
            keygrip = line.replace(/(grp|:)/g, '').trim();
            break;
        }
    }
    return keygrip;
};
exports.parseKeygripFromGpgColonsOutput = parseKeygripFromGpgColonsOutput;
const getKeygrip = (fingerprint) => __awaiter(void 0, void 0, void 0, function* () {
    return yield exec
        .getExecOutput('gpg', ['--batch', '--with-colons', '--with-keygrip', '--list-secret-keys', fingerprint], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        return (0, exports.parseKeygripFromGpgColonsOutput)(res.stdout, fingerprint);
    });
});
exports.getKeygrip = getKeygrip;
const configureAgent = (homedir, config) => __awaiter(void 0, void 0, void 0, function* () {
    const gpgAgentConf = path.join(homedir, 'gpg-agent.conf');
    yield fs.writeFile(gpgAgentConf, config, function (err) {
        if (err)
            throw err;
    });
    yield gpgConnectAgent('RELOADAGENT');
});
exports.configureAgent = configureAgent;
const presetPassphrase = (keygrip, passphrase) => __awaiter(void 0, void 0, void 0, function* () {
    const hexPassphrase = Buffer.from(passphrase, 'utf8').toString('hex').toUpperCase();
    yield gpgConnectAgent(`PRESET_PASSPHRASE ${keygrip} -1 ${hexPassphrase}`);
    return yield gpgConnectAgent(`KEYINFO ${keygrip}`);
});
exports.presetPassphrase = presetPassphrase;
const setTrustLevel = (keyID, trust) => __awaiter(void 0, void 0, void 0, function* () {
    yield exec
        .getExecOutput('gpg', ['--batch', '--no-tty', '--command-fd', '0', '--edit-key', keyID], {
        ignoreReturnCode: true,
        silent: true,
        input: Buffer.from(`trust\n${trust}\ny\nquit\n`)
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
    });
});
exports.setTrustLevel = setTrustLevel;
const deleteKey = (fingerprint) => __awaiter(void 0, void 0, void 0, function* () {
    yield exec
        .getExecOutput('gpg', ['--batch', '--yes', '--delete-secret-keys', fingerprint], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
    });
    yield exec
        .getExecOutput('gpg', ['--batch', '--yes', '--delete-keys', fingerprint], {
        ignoreReturnCode: true,
        silent: true
    })
        .then(res => {
        if (res.stderr.length > 0 && res.exitCode != 0) {
            throw new Error(res.stderr);
        }
    });
});
exports.deleteKey = deleteKey;
const killAgent = () => __awaiter(void 0, void 0, void 0, function* () {
    yield gpgConnectAgent('KILLAGENT');
});
exports.killAgent = killAgent;
